// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1QZ_0","name":"ConsentHeader_name__3DDQN","birthday":"ConsentHeader_birthday__2BhVc","skeleton":"ConsentHeader_skeleton__hx4DG"};